import { call, put, select, takeEvery, all } from 'redux-saga/effects';

import { ACCEPT_COOKIES, CHECK_APP_VERSION } from './constants';
import { api_POST, api_PUT } from 'modules/Api/saga';
import {gate, work} from "modules/Api/saga";
import { selectApiKey } from '../../modules/Api/selectors';
import { api_GET, apiError } from '../../modules/Api/saga';
import { GET } from "../../utils/request";

function* acceptCookies(){

  let a = ACCEPT_COOKIES;

  yield gate(a, function* () {
    yield work(a, function* () {
      let loggedIn = yield select(selectApiKey());

      if(loggedIn){
        let result = yield call(api_GET,{ request : {path : `accept-cookies`}});
      }

    });
  });

}

function* checkAppVersion() {
  const clientVersion = window.__BUILD_HASH__;
  let latestVersion = null;
  try {
    let result = (yield call(GET, '/manifest.json')).data;
    const row = result['main.js'];
    latestVersion = row.split('.')[1];
  } catch(e) {}
  if (!latestVersion || !clientVersion) {
    return;
  }
  if (latestVersion !== clientVersion) {
    yield apiError('De applicatie is ge-update, gebruik refresh (Apple: Command-shift-R | Windows: CTRL-F5');
  }
}

export function* appSagas(){
  yield all([
    takeEvery(ACCEPT_COOKIES, acceptCookies),
    takeEvery(CHECK_APP_VERSION, checkAppVersion),
  ]);
}
